import { createSlice } from "@reduxjs/toolkit";

const statsSlice = createSlice({
  name: "stats",
  initialState: {},
  reducers: {
    setStats: (state, action) => action.payload,
  },
});

export const { setStats } = statsSlice.actions;
export default statsSlice.reducer;
